import React, { useState, useRef } from "react";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import "../App.css";
import { useAuth } from "../contexts/AuthContext";
import { useHistory } from "react-router-dom";
import { Alert } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";

import {
  changeDoorman,
  changeHotel,
  setDoorCode,
  changeCode,
} from "../redux/account-prefs";
import { setContact } from "../redux/user";

const ZIP_CODES = [
  "11550",
"11758",
"11590",
"11003",
"11520",
"11756",
"11580",
"11040",
"11801",
"11554",
"11710",
"11735",
"11566",
"11510",
"11793",
"11530",
"11572",
"11561",
"11803",
"11001",
"11050",
"11570",
"11553",
"11542",
"11791",
"11010",
"11552",
"11762",
"11714",
"11563",
"11581",
"11783",
"11501",
"11021",
"11030",
"11575",
"11702",
"11753",
"11576",
"11545",
"11598",
"11577",
"11596",
"11518",
"11771",
"11023",
"11797",
"11557",
"11559",
"11096",
"11565",
"11516",
"11507",
"11558",
"11560",
"11024",
"11514",
"11568",
"11020",
"11579",
"11709",
"11804",
"11732",
"11548",
"11042",
"11547",
"11569",
"11509",
"11765",
"11556",
"11549",
"11815",
"11022",
"11535",
"11594",
"11597",
"11736",
"11774",
"11819",
"11854",
"11855",
"11571",
"11582",
"11592",
"11595",
"11599",
"11737",
"11773",
"11802",
"11853",
"11002",
"11025",
"11026",
"11027",
"11041",
"11043",
"11044",
"11051",
"11052",
"11053",
"11054",
"11055",
"11099",
"11531",
"11536",
"11551",
"11555",
"10001",
"10451",
"10002",
"10452",
"10003",
"10453",
"10004",
"10454",
"10005",
"10455",
"10006",
"10456",
"10007",
"10457",
"10009",
"10458",
"10010",
"10459",
"10011",
"10460",
"10012",
"10461",
"10013",
"10462",
"10014",
"10463",
"10015",
"10464",
"10016",
"10465",
"10017",
"10466",
"10018",
"10467",
"10019",
"10468",
"10020",
"10469",
"10021",
"10470",
"10022",
"10471",
"10023",
"10472",
"10024",
"10473",
"10025",
"10474",
"10026",
"10475",
"10027",
"11201",
"10028",
"11203",
"10029",
"11204",
"10030",
"11205",
"10031",
"11206",
"10032",
"11207",
"10033",
"11208",
"10034",
"11209",
"10035",
"11210",
"10036",
"11211",
"10037",
"11212",
"10038",
"11213",
"10039",
"11214",
"10040",
"11215",
"10041",
"11216",
"10044",
"11217",
"10045",
"11218",
"10048",
"11219",
"10055",
"11220",
"10060",
"11221",
"10069",
"11222",
"10090",
"11223",
"10095",
"11224",
"10098",
"11225",
"10099",
"11226",
"10103",
"11228",
"10104",
"11229",
"10105",
"11230",
"10106",
"11231",
"10107",
"11232",
"10110",
"11233",
"10111",
"11234",
"10112",
"11235",
"10115",
"11236",
"10118",
"11237",
"10119",
"11238",
"10120",
"11239",
"10121",
"11241",
"10122",
"11242",
"10123",
"11243",
"10128",
"11249",
"10151",
"11252",
"10152",
"11256",
"10153",
"10001",
"10154",
"10002",
"10155",
"10003",
"10158",
"10004",
"10161",
"10005",
"10162",
"10006",
"10165",
"10007",
"10166",
"10009",
"10167",
"10010",
"10168",
"10011",
"10169",
"10012",
"10170",
"10013",
"10171",
"10014",
"10172",
"10015",
"10173",
"10016",
"10174",
"10017",
"10175",
"10018",
"10176",
"10019",
"10177",
"10020",
"10178",
"10021",
"10199",
"10022",
"10270",
"10023",
"10271",
"10024",
"10278",
"10025",
"10279",
"10026",
"10280",
"10027",
"10281",
"10028",
"10282",
"10029",
"10030",
"10031",
"10032",
"10033",
"10034",
"10035",
"10036",
"10037",
"10038",
"10039",
"10040",
"10041",
"10044",
"10451",
"10045",
"10452",
"10048",
"10453",
"10055",
"10454",
"10060",
"10455",
"10069",
"10456",
"10090",
"10457",
"10095",
"10458",
"10098",
"10459",
"10099",
"10460",
"10103",
"10461",
"10104",
"10462",
"10105",
"10463",
"10106",
"10464",
"10107",
"10465",
"10110",
"10466",
"10111",
"10467",
"10112",
"10468",
"10115",
"10469",
"10118",
"10470",
"10119",
"10471",
"10120",
"10472",
"10121",
"10473",
"10122",
"10474",
"10123",
"10475",
"10128",
"11004",
"10151",
"11101",
"10152",
"11102",
"10153",
"11103",
"10154",
"11104",
"10155",
"11105",
"10158",
"11106",
"10161",
"11109",
"10162",
"11201",
"10165",
"11203",
"10166",
"11204",
"10167",
"11205",
"10168",
"11206",
"10169",
"11207",
"10170",
"11208",
"10171",
"11209",
"10172",
"11210",
"10173",
"11211",
"10174",
"11212",
"10175",
"11213",
"10176",
"11214",
"10177",
"11215",
"10178",
"11216",
"10199",
"11217",
"10270",
"11218",
"10271",
"11219",
"10278",
"11220",
"10279",
"11221",
"10280",
"11222",
"10281",
"11223",
"10282",
"11224",
"11101",
"11225",
"11102",
"11226",
"11103",
"11228",
"11004",
"11229",
"11104",
"11230",
"11105",
"11231",
"11106",
"11232",
"11109",
"11233",
"11351",
"11234",
"11354",
"11235",
"11355",
"11236",
"11356",
"11237",
"11357",
"11238",
"11358",
"11239",
"11359",
"11241",
"11360",
"11242",
"11361",
"11243",
"11362",
"11249",
"11363",
"11252",
"11364",
"11256",
"11365",
"11351",
"11366",
"11354",
"11367",
"11355",
"11368",
"11356",
"11369",
"11357",
"11370",
"11358",
"11371",
"11359",
"11372",
"11360",
"11373",
"11361",
"11374",
"11362",
"11375",
"11363",
"11377",
"11364",
"11378",
"11365",
"11379",
"11366",
"11385",
"11367",
"11411",
"11368",
"11412",
"11369",
"11413",
"11370",
"11414",
"11371",
"11415",
"11372",
"11416",
"11373",
"11417",
"11374",
"11418",
"11375",
"11419",
"11377",
"11420",
"11378",
"11421",
"11379",
"11422",
"11385",
"11423",
"11411",
"11426",
"11412",
"11427",
"11413",
"11428",
"11414",
"11429",
"11415",
"11430",
"11416",
"11432",
"11417",
"11433",
"11418",
"11434",
"11419",
"11435",
"11420",
"11436",
"11421",
"11691",
"11422",
"11692",
"11423",
"11693",
"11426",
"11694",
"11427",
"11697",
"11428",
"11429",
"11430",
"11432",
"11433",
"11434",
"11435",
"11436",
"11691",
"11692",
"11693",
"11694",
"11550",
"11758",
"11590",
"11003",
"11520",
"11756",
"11580",
"11040",
"11801",
"11554",
"11710",
"11735",
"11566",
"11510",
"11793",
"11530",
"11572",
"11561",
"11803",
"11001",
"11050",
"11570",
"11553",
"11542",
"11791",
"11010",
"11552",
"11762",
"11714",
"11563",
"11581",
"11783",
"11501",
"11021",
"11030",
"11575",
"11702",
"11753",
"11576",
"11545",
"11598",
"11577",
"11596",
"11518",
"11771",
"11023",
"11797",
"11557",
"11559",
"11096",
"11565",
"11516",
"11507",
"11558",
"11560",
"11024",
"11514",
"11568",
"11020",
"11579",
"11709",
"11804",
"11732",
"11548",
"11042",
"11547",
"11569",
"11509",
"11765",
"11556",
"11549",
"11815",
"11022",
"11535",
"11594",
"11597",
"11736",
"11774",
"11819",
"11854",
"11855",
"11571",
"11582",
"11592",
"11595",
"11599",
"11737",
"11773",
"11802",
"11853",
"11002",
"11025",
"11026",
"11027",
"11041",
"11043",
"11044",
"11051",
"11052",
"11053",
"11054",
"11055",
"11099",
"11531",
"11536",
"11551",
"11555",
"10001",
"10451",
"10002",
"10452",
"10003",
"10453",
"10004",
"10454",
"10005",
"10455",
"10006",
"10456",
"10007",
"10457",
"10009",
"10458",
"10010",
"10459",
"10011",
"10460",
"10012",
"10461",
"10013",
"10462",
"10014",
"10463",
"10015",
"10464",
"10016",
"10465",
"10017",
"10466",
"10018",
"10467",
"10019",
"10468",
"10020",
"10469",
"10021",
"10470",
"10022",
"10471",
"10023",
"10472",
"10024",
"10473",
"10025",
"10474",
"10026",
"10475",
"10027",
"11201",
"10028",
"11203",
"10029",
"11204",
"10030",
"11205",
"10031",
"11206",
"10032",
"11207",
"10033",
"11208",
"10034",
"11209",
"10035",
"11210",
"10036",
"11211",
"10037",
"11212",
"10038",
"11213",
"10039",
"11214",
"10040",
"11215",
"10041",
"11216",
"10044",
"11217",
"10045",
"11218",
"10048",
"11219",
"10055",
"11220",
"10060",
"11221",
"10069",
"11222",
"10090",
"11223",
"10095",
"11224",
"10098",
"11225",
"10099",
"11226",
"10103",
"11228",
"10104",
"11229",
"10105",
"11230",
"10106",
"11231",
"10107",
"11232",
"10110",
"11233",
"10111",
"11234",
"10112",
"11235",
"10115",
"11236",
"10118",
"11237",
"10119",
"11238",
"10120",
"11239",
"10121",
"11241",
"10122",
"11242",
"10123",
"11243",
"10128",
"11249",
"10151",
"11252",
"10152",
"11256",
"10153",
"10001",
"10154",
"10002",
"10155",
"10003",
"10158",
"10004",
"10161",
"10005",
"10162",
"10006",
"10165",
"10007",
"10166",
"10009",
"10167",
"10010",
"10168",
"10011",
"10169",
"10012",
"10170",
"10013",
"10171",
"10014",
"10172",
"10015",
"10173",
"10016",
"10174",
"10017",
"10175",
"10018",
"10176",
"10019",
"10177",
"10020",
"10178",
"10021",
"10199",
"10022",
"10270",
"10023",
"10271",
"10024",
"10278",
"10025",
"10279",
"10026",
"10280",
"10027",
"10281",
"10028",
"10282",
"10029",
"10030",
"10031",
"10032",
"10033",
"10034",
"10035",
"10036",
"10037",
"10038",
"10039",
"10040",
"10041",
"10044",
"10451",
"10045",
"10452",
"10048",
"10453",
"10055",
"10454",
"10060",
"10455",
"10069",
"10456",
"10090",
"10457",
"10095",
"10458",
"10098",
"10459",
"10099",
"10460",
"10103",
"10461",
"10104",
"10462",
"10105",
"10463",
"10106",
"10464",
"10107",
"10465",
"10110",
"10466",
"10111",
"10467",
"10112",
"10468",
"10115",
"10469",
"10118",
"10470",
"10119",
"10471",
"10120",
"10472",
"10121",
"10473",
"10122",
"10474",
"10123",
"10475",
"10128",
"11004",
"10151",
"11101",
"10152",
"11102",
"10153",
"11103",
"10154",
"11104",
"10155",
"11105",
"10158",
"11106",
"10161",
"11109",
"10162",
"11201",
"10165",
"11203",
"10166",
"11204",
"10167",
"11205",
"10168",
"11206",
"10169",
"11207",
"10170",
"11208",
"10171",
"11209",
"10172",
"11210",
"10173",
"11211",
"10174",
"11212",
"10175",
"11213",
"10176",
"11214",
"10177",
"11215",
"10178",
"11216",
"10199",
"11217",
"10270",
"11218",
"10271",
"11219",
"10278",
"11220",
"10279",
"11221",
"10280",
"11222",
"10281",
"11223",
"10282",
"11224",
"11101",
"11225",
"11102",
"11226",
"11103",
"11228",
"11004",
"11229",
"11104",
"11230",
"11105",
"11231",
"11106",
"11232",
"11109",
"11233",
"11351",
"11234",
"11354",
"11235",
"11355",
"11236",
"11356",
"11237",
"11357",
"11238",
"11358",
"11239",
"11359",
"11241",
"11360",
"11242",
"11361",
"11243",
"11362",
"11249",
"11363",
"11252",
"11364",
"11256",
"11365",
"11351",
"11366",
"11354",
"11367",
"11355",
"11368",
"11356",
"11369",
"11357",
"11370",
"11358",
"11371",
"11359",
"11372",
"11360",
"11373",
"11361",
"11374",
"11362",
"11375",
"11363",
"11377",
"11364",
"11378",
"11365",
"11379",
"11366",
"11385",
"11367",
"11411",
"11368",
"11412",
"11369",
"11413",
"11370",
"11414",
"11371",
"11415",
"11372",
"11416",
"11373",
"11417",
"11374",
"11418",
"11375",
"11419",
"11377",
"11420",
"11378",
"11421",
"11379",
"11422",
"11385",
"11423",
"11411",
"11426",
"11412",
"11427",
"11413",
"11428",
"11414",
"11429",
"11415",
"11430",
"11416",
"11432",
"11417",
"11433",
"11418",
"11434",
"11419",
"11435",
"11420",
"11436",
"11421",
"11691",
"11422",
"11692",
"11423",
"11693",
"11426",
"11694",
"11427",
"11697",
"11428",
"11429",
"11430",
"11432",
"11433",
"11434",
"11435",
"11436",
"11691",
"11692",
"11693",
"11694",
"11550",
"11758",
"11590",
"11003",
"11520",
"11756",
"11580",
"11040",
"11801",
"11554",
"11710",
"11735",
"11566",
"11510",
"11793",
"11530",
"11572",
"11561",
"11803",
"11001",
"11050",
"11570",
"11553",
"11542",
"11791",
"11010",
"11552",
"11762",
"11714",
"11563",
"11581",
"11783",
"11501",
"11021",
"11030",
"11575",
"11702",
"11753",
"11576",
"11545",
"11598",
"11577",
"11596",
"11518",
"11771",
"11023",
"11797",
"11557",
"11559",
"11096",
"11565",
"11516",
"11507",
"11558",
"11560",
"11024",
"11514",
"11568",
"11020",
"11579",
"11709",
"11804",
"11732",
"11548",
"11042",
"11547",
"11569",
"11509",
"11765",
"11556",
"11549",
"11815",
"11022",
"11535",
"11594",
"11597",
"11736",
"11774",
"11819",
"11854",
"11855",
"11571",
"11582",
"11592",
"11595",
"11599",
"11737",
"11773",
"11802",
"11853",
"11002",
"11025",
"11026",
"11027",
"11041",
"11043",
"11044",
"11051",
"11052",
"11053",
"11054",
"11055",
"11099",
"11531",
"11536",
"11551",
"11555",
"10001",
"10451",
"10002",
"10452",
"10003",
"10453",
"10004",
"10454",
"10005",
"10455",
"10006",
"10456",
"10007",
"10457",
"10009",
"10458",
"10010",
"10459",
"10011",
"10460",
"10012",
"10461",
"10013",
"10462",
"10014",
"10463",
"10015",
"10464",
"10016",
"10465",
"10017",
"10466",
"10018",
"10467",
"10019",
"10468",
"10020",
"10469",
"10021",
"10470",
"10022",
"10471",
"10023",
"10472",
"10024",
"10473",
"10025",
"10474",
"10026",
"10475",
"10027",
"11201",
"10028",
"11203",
"10029",
"11204",
"10030",
"11205",
"10031",
"11206",
"10032",
"11207",
"10033",
"11208",
"10034",
"11209",
"10035",
"11210",
"10036",
"11211",
"10037",
"11212",
"10038",
"11213",
"10039",
"11214",
"10040",
"11215",
"10041",
"11216",
"10044",
"11217",
"10045",
"11218",
"10048",
"11219",
"10055",
"11220",
"10060",
"11221",
"10069",
"11222",
"10090",
"11223",
"10095",
"11224",
"10098",
"11225",
"10099",
"11226",
"10103",
"11228",
"10104",
"11229",
"10105",
"11230",
"10106",
"11231",
"10107",
"11232",
"10110",
"11233",
"10111",
"11234",
"10112",
"11235",
"10115",
"11236",
"10118",
"11237",
"10119",
"11238",
"10120",
"11239",
"10121",
"11241",
"10122",
"11242",
"10123",
"11243",
"10128",
"11249",
"10151",
"11252",
"10152",
"11256",
"10153",
"10001",
"10154",
"10002",
"10155",
"10003",
"10158",
"10004",
"10161",
"10005",
"10162",
"10006",
"10165",
"10007",
"10166",
"10009",
"10167",
"10010",
"10168",
"10011",
"10169",
"10012",
"10170",
"10013",
"10171",
"10014",
"10172",
"10015",
"10173",
"10016",
"10174",
"10017",
"10175",
"10018",
"10176",
"10019",
"10177",
"10020",
"10178",
"10021",
"10199",
"10022",
"10270",
"10023",
"10271",
"10024",
"10278",
"10025",
"10279",
"10026",
"10280",
"10027",
"10281",
"10028",
"10282",
"10029",
"10030",
"10031",
"10032",
"10033",
"10034",
"10035",
"10036",
"10037",
"10038",
"10039",
"10040",
"10041",
"10044",
"10451",
"10045",
"10452",
"10048",
"10453",
"10055",
"10454",
"10060",
"10455",
"10069",
"10456",
"10090",
"10457",
"10095",
"10458",
"10098",
"10459",
"10099",
"10460",
"10103",
"10461",
"10104",
"10462",
"10105",
"10463",
"10106",
"10464",
"10107",
"10465",
"10110",
"10466",
"10111",
"10467",
"10112",
"10468",
"10115",
"10469",
"10118",
"10470",
"10119",
"10471",
"10120",
"10472",
"10121",
"10473",
"10122",
"10474",
"10123",
"10475",
"10128",
"11004",
"10151",
"11101",
"10152",
"11102",
"10153",
"11103",
"10154",
"11104",
"10155",
"11105",
"10158",
"11106",
"10161",
"11109",
"10162",
"11201",
"10165",
"11203",
"10166",
"11204",
"10167",
"11205",
"10168",
"11206",
"10169",
"11207",
"10170",
"11208",
"10171",
"11209",
"10172",
"11210",
"10173",
"11211",
"10174",
"11212",
"10175",
"11213",
"10176",
"11214",
"10177",
"11215",
"10178",
"11216",
"10199",
"11217",
"10270",
"11218",
"10271",
"11219",
"10278",
"11220",
"10279",
"11221",
"10280",
"11222",
"10281",
"11223",
"10282",
"11224",
"11101",
"11225",
"11102",
"11226",
"11103",
"11228",
"11004",
"11229",
"11104",
"11230",
"11105",
"11231",
"11106",
"11232",
"11109",
"11233",
"11351",
"11234",
"11354",
"11235",
"11355",
"11236",
"11356",
"11237",
"11357",
"11238",
"11358",
"11239",
"11359",
"11241",
"11360",
"11242",
"11361",
"11243",
"11362",
"11249",
"11363",
"11252",
"11364",
"11256",
"11365",
"11351",
"11366",
"11354",
"11367",
"11355",
"11368",
"11356",
"11369",
"11357",
"11370",
"11358",
"11371",
"11359",
"11372",
"11360",
"11373",
"11361",
"11374",
"11362",
"11375",
"11363",
"11377",
"11364",
"11378",
"11365",
"11379",
"11366",
"11385",
"11367",
"11411",
"11368",
"11412",
"11369",
"11413",
"11370",
"11414",
"11371",
"11415",
"11372",
"11416",
"11373",
"11417",
"11374",
"11418",
"11375",
"11419",
"11377",
"11420",
"11378",
"11421",
"11379",
"11422",
"11385",
"11423",
"11411",
"11426",
"11412",
"11427",
"11413",
"11428",
"11414",
"11429",
"11415",
"11430",
"11416",
"11432",
"11417",
"11433",
"11418",
"11434",
"11419",
"11435",
"11420",
"11436",
"11421",
"11691",
"11422",
"11692",
"11423",
"11693",
"11426",
"11694",
"11427",
"11697",
"11428",
"11429",
"11430",
"11432",
"11433",
"11434",
"11435",
"11436",
"11691",
"11692",
"11693",
"11694",
"11550",
"11758",
"11590",
"11003",
"11520",
"11756",
"11580",
"11040",
"11801",
"11554",
"11710",
"11735",
"11566",
"11510",
"11793",
"11530",
"11572",
"11561",
"11803",
"11001",
"11050",
"11570",
"11553",
"11542",
"11791",
"11010",
"11552",
"11762",
"11714",
"11563",
"11581",
"11783",
"11501",
"11021",
"11030",
"11575",
"11702",
"11753",
"11576",
"11545",
"11598",
"11577",
"11596",
"11518",
"11771",
"11023",
"11797",
"11557",
"11559",
"11096",
"11565",
"11516",
"11507",
"11558",
"11560",
"11024",
"11514",
"11568",
"11020",
"11579",
"11709",
"11804",
"11732",
"11548",
"11042",
"11547",
"11569",
"11509",
"11765",
"11556",
"11549",
"11815",
"11022",
"11535",
"11594",
"11597",
"11736",
"11774",
"11819",
"11854",
"11855",
"11571",
"11582",
"11592",
"11595",
"11599",
"11737",
"11773",
"11802",
"11853",
"11002",
"11025",
"11026",
"11027",
"11041",
"11043",
"11044",
"11051",
"11052",
"11053",
"11054",
"11055",
"11099",
"11531",
"11536",
"11551",
"11555",
"10001",
"10451",
"10002",
"10452",
"10003",
"10453",
"10004",
"10454",
"10005",
"10455",
"10006",
"10456",
"10007",
"10457",
"10009",
"10458",
"10010",
"10459",
"10011",
"10460",
"10012",
"10461",
"10013",
"10462",
"10014",
"10463",
"10015",
"10464",
"10016",
"10465",
"10017",
"10466",
"10018",
"10467",
"10019",
"10468",
"10020",
"10469",
"10021",
"10470",
"10022",
"10471",
"10023",
"10472",
"10024",
"10473",
"10025",
"10474",
"10026",
"10475",
"10027",
"11201",
"10028",
"11203",
"10029",
"11204",
"10030",
"11205",
"10031",
"11206",
"10032",
"11207",
"10033",
"11208",
"10034",
"11209",
"10035",
"11210",
"10036",
"11211",
"10037",
"11212",
"10038",
"11213",
"10039",
"11214",
"10040",
"11215",
"10041",
"11216",
"10044",
"11217",
"10045",
"11218",
"10048",
"11219",
"10055",
"11220",
"10060",
"11221",
"10069",
"11222",
"10090",
"11223",
"10095",
"11224",
"10098",
"11225",
"10099",
"11226",
"10103",
"11228",
"10104",
"11229",
"10105",
"11230",
"10106",
"11231",
"10107",
"11232",
"10110",
"11233",
"10111",
"11234",
"10112",
"11235",
"10115",
"11236",
"10118",
"11237",
"10119",
"11238",
"10120",
"11239",
"10121",
"11241",
"10122",
"11242",
"10123",
"11243",
"10128",
"11249",
"10151",
"11252",
"10152",
"11256",
"10153",
"10001",
"10154",
"10002",
"10155",
"10003",
"10158",
"10004",
"10161",
"10005",
"10162",
"10006",
"10165",
"10007",
"10166",
"10009",
"10167",
"10010",
"10168",
"10011",
"10169",
"10012",
"10170",
"10013",
"10171",
"10014",
"10172",
"10015",
"10173",
"10016",
"10174",
"10017",
"10175",
"10018",
"10176",
"10019",
"10177",
"10020",
"10178",
"10021",
"10199",
"10022",
"10270",
"10023",
"10271",
"10024",
"10278",
"10025",
"10279",
"10026",
"10280",
"10027",
"10281",
"10028",
"10282",
"10029",
"10030",
"10031",
"10032",
"10033",
"10034",
"10035",
"10036",
"10037",
"10038",
"10039",
"10040",
"10041",
"10044",
"10451",
"10045",
"10452",
"10048",
"10453",
"10055",
"10454",
"10060",
"10455",
"10069",
"10456",
"10090",
"10457",
"10095",
"10458",
"10098",
"10459",
"10099",
"10460",
"10103",
"10461",
"10104",
"10462",
"10105",
"10463",
"10106",
"10464",
"10107",
"10465",
"10110",
"10466",
"10111",
"10467",
"10112",
"10468",
"10115",
"10469",
"10118",
"10470",
"10119",
"10471",
"10120",
"10472",
"10121",
"10473",
"10122",
"10474",
"10123",
"10475",
"10128",
"11004",
"10151",
"11101",
"10152",
"11102",
"10153",
"11103",
"10154",
"11104",
"10155",
"11105",
"10158",
"11106",
"10161",
"11109",
"10162",
"11201",
"10165",
"11203",
"10166",
"11204",
"10167",
"11205",
"10168",
"11206",
"10169",
"11207",
"10170",
"11208",
"10171",
"11209",
"10172",
"11210",
"10173",
"11211",
"10174",
"11212",
"10175",
"11213",
"10176",
"11214",
"10177",
"11215",
"10178",
"11216",
"10199",
"11217",
"10270",
"11218",
"10271",
"11219",
"10278",
"11220",
"10279",
"11221",
"10280",
"11222",
"10281",
"11223",
"10282",
"11224",
"11101",
"11225",
"11102",
"11226",
"11103",
"11228",
"11004",
"11229",
"11104",
"11230",
"11105",
"11231",
"11106",
"11232",
"11109",
"11233",
"11351",
"11234",
"11354",
"11235",
"11355",
"11236",
"11356",
"11237",
"11357",
"11238",
"11358",
"11239",
"11359",
"11241",
"11360",
"11242",
"11361",
"11243",
"11362",
"11249",
"11363",
"11252",
"11364",
"11256",
"11365",
"11351",
"11366",
"11354",
"11367",
"11355",
"11368",
"11356",
"11369",
"11357",
"11370",
"11358",
"11371",
"11359",
"11372",
"11360",
"11373",
"11361",
"11374",
"11362",
"11375",
"11363",
"11377",
"11364",
"11378",
"11365",
"11379",
"11366",
"11385",
"11367",
"11411",
"11368",
"11412",
"11369",
"11413",
"11370",
"11414",
"11371",
"11415",
"11372",
"11416",
"11373",
"11417",
"11374",
"11418",
"11375",
"11419",
"11377",
"11420",
"11378",
"11421",
"11379",
"11422",
"11385",
"11423",
"11411",
"11426",
"11412",
"11427",
"11413",
"11428",
"11414",
"11429",
"11415",
"11430",
"11416",
"11432",
"11417",
"11433",
"11418",
"11434",
"11419",
"11435",
"11420",
"11436",
"11421",
"11691",
"11422",
"11692",
"11423",
"11693",
"11426",
"11694",
"11427",
"11697",
"11428",
"11429",
"11430",
"11432",
"11433",
"11434",
"11435",
"11436",
"11691",
"11692",
"11693",
"11694",
"11697"
];

export default function Address() {
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { addAddress, getZipCode } = useAuth();
  const history = useHistory();
  const aptRef = useRef();
  const zipRef = useRef();

  const { doorman, code, hotel, code_door } = useSelector(
    (state) => state.accountPref
  );
  const { id, name, phone } = useSelector((state) => state.user);
  const [value, setValue] = useState(null);

  const dispatch = useDispatch();

  async function handleDoorChange(e) {
    dispatch(setDoorCode(e.target.value));
  }

  async function handleSubmit(e) {
    e.preventDefault();

    try {
      if (error.length > 0) {
        throw new Error("Not In Service Area");
      }
      setError("");
      setLoading(true);

      var aptVal;
      if (!aptRef.current) {
        aptVal = "N/A";
      } else {
        aptVal = aptRef.current.value;
      }

      if (!value) {
        setError("Please add an address");
      }

      dispatch(
        setContact(
          document.querySelector('input[name="contact"]:checked').value
        )
      );

      const options = {
        Doorman: doorman,
        Hotel: hotel,
        Door_Gate_Code: code_door,
        Contact: document.querySelector('input[name="contact"]:checked').value,
      };
      addAddress(
        id,
        value.value.terms[0].value + " " + value.value.terms[1].value,
        value.value.terms[2].value,
        value.value.terms[3].value,
        aptVal,
        name,
        options,
        phone,
        zipRef.current.value
      );

      history.push("/time");
    } catch (err) {
      console.log(err.message);
    }

    setLoading(false);
  }

  async function getAddress(val) {
    setLoading(true);
    const res = await getZipCode(val.value.place_id);
    setValue(val);
    zipRef.current.value = res;
    if (ZIP_CODES.includes(zipRef.current.value)) setError("");
    else setError("Not In Service Area");
    setLoading(false);
  }

  return (
    <div>
        <div>
          <div className="homepage">
            {error && <Alert variant="danger">{error}</Alert>}
          </div>
          <span
            style={{
              fontWeight: "bold",
              display: "flex",
              justifyContent: "center",
            }}
          >
            Let's start with your address
          </span>

          <div style={{ display: "flex", flexDirection: "column" }}>
            <GooglePlacesAutocomplete
              apiKey={process.env.REACT_APP_GOOGLE_API_KEY}
              autocompletionRequest={{
                componentRestrictions: {
                  country: ["us"],
                },
              }}
              selectProps={{
                value,
                onChange: (val) => {
                  getAddress(val);
                },
                placeholder: "Enter Address",
              }}
            />
            <input
              maxLength={5}
              type="number"
              id="zipcode"
              name="zipcode"
              placeholder="Zip Code"
              ref={zipRef}
              style={{ marginBlock: "8px" }}
              className="form-control"
            />

            <input
              type="text"
              id="apt"
              name="apt"
              placeholder="Apartment #"
              ref={aptRef}
              style={{ marginBlock: "8px" }}
              className="form-control"
            />
          </div>
          <div
            style={{
              fontWeight: "bold",
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
              textAlign: "center",
              padding: "5px",
            }}
          >
            Other Information
          </div>
          <div>
            <div>
              <input
                type="checkbox"
                id="doorman"
                name="doorman"
                value={doorman}
                onChange={() => {
                  dispatch(changeDoorman());
                }}
              />
              <span style={{ padding: "5px" }}>
                Live in a doorman building?{" "}
              </span>
            </div>
            <div>
              <input
                type="checkbox"
                id="hotel"
                name="hotel"
                value={hotel}
                onChange={() => {
                  dispatch(changeHotel());
                }}
              />
              <span style={{ padding: "5px" }}>
                Are you a guest of a hotel or motel?{" "}
              </span>
            </div>
            <div style={{ display: "flex" }}>
              <label>
                {" "}
                <input
                  type="checkbox"
                  id="code"
                  name="code"
                  value={code}
                  onChange={() => {
                    dispatch(changeCode());
                  }}
                />
              </label>

              <span style={{ margin: "5px" }}>
                Will you give us a key or door code?
              </span>
              {code && (
                <input
                  className="form-control"
                  type="text"
                  id="code"
                  name="code"
                  placeholder="Door/Gate Code"
                  value={code_door}
                  onChange={(e) => handleDoorChange(e)}
                />
              )}
            </div>
            <span style={{ padding: "20px" }}>(If Key, enter 'Yes') </span>
          </div>

          <div
            style={{
              fontWeight: "bold",
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
              textAlign: "center",
              padding: "5px",
            }}
          >
            Contact Preference
          </div>
          <div className="d-flex flex-column">
            <div style={{ padding: 5 }}>
              <label>
                {" "}
                <input
                  type="radio"
                  value="Call"
                  name="contact"
                  defaultChecked={true}
                  readOnly
                />{" "}
                Call
              </label>
            </div>

            <div style={{ padding: 5 }}>
              {" "}
              <label>
                <input type="radio" value="Text" name="contact" readOnly /> Text
              </label>
            </div>
          </div>
          <div className="address">
            <button disabled={loading} onClick={handleSubmit}>
              Schedule Service
            </button>
          </div>
        </div>
    </div>
  );
}
